<template>
  <base-container ref="container" :isLoading="loading">
    <ArtisanGrid
      ref="ward"
      metaKey="BedWardInfo"
      rightWidth="25%"
      @row-click="setWardGroup"
      :metaInited="metaInited"
    >
      <template #rightAside>
        <artisan-group style="height: 100%">
          <el-row
            slot="header"
            type="flex"
            justify="space-between"
            align="middle"
          >
            <span>医疗组设置--{{ row.name }}</span>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-plus"
              circle
              plain
              :disabled="!row.id"
              @click="addMembers('0')"
            ></el-button>
          </el-row>
          <el-tree
            :data="groups"
            node-key="id"
            default-expand-all
            :props="props"
            :expand-on-click-node="false"
          >
            <el-row
              style="flex: 1"
              type="flex"
              justify="space-between"
              align="middle"
              slot-scope="{ node, data }"
            >
              <div
                :class="data.groupId == '0' ? 'color-danger' : 'color-primary'"
              >
                {{ node.label }}
              </div>
              <span>({{ data.groupId == "0" ? "组长" : "组员" }})</span>
              <div style="margin-right: 15px">
                <el-button
                  v-if="data.groupId == '0'"
                  type="text"
                  size="mini"
                  icon="el-icon-plus"
                  @click="addMembers(data.id)"
                >
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-delete"
                  class="color-danger"
                  @click="removeMember(data)"
                >
                </el-button>
              </div>
            </el-row>
          </el-tree>
        </artisan-group>
      </template>
      <template #warnMatterForm="{ row }">
        <div>
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            mode="default"
          />
          <Editor
            style="height: 300px; overflow-y: hidden"
            v-model="row.warnMatter"
            :defaultConfig="{ placeholder: '请输入内容...' }"
            mode="default"
            @onCreated="onCreated"
          />
        </div>
      </template>
      <template #expand="{ row }">
        <el-row v-if="row.warnMatter">
          <el-col :offset="8" :span="8" v-html="row.warnMatter"> </el-col>
        </el-row>
        <el-empty v-else description="未设置注意事项！"></el-empty>
      </template>
    </ArtisanGrid>
    <artisan-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      :isLoading="dialog.loading"
      height="75%"
      width="75%"
      ref="dialog"
    >
      <ArtisanGrid
        v-if="dialog.show"
        ref="doctor"
        metaKey="BasisDoctorInfo"
        :metaInited="metaInited"
        :rowBtnPermission="rowBtnPermission"
        :query="{ deptNames: row.name }"
      >
        <template #toolHeader>
          <el-row type="flex" align="middle" style="min-height: 25px">
            选中的医生:
            <el-tag
              class="margin-h3"
              size="small"
              effect="dark"
              v-for="(doctor, i) in doctors"
              :key="doctor.id"
              closable
              type="primary"
              @close="doctors.splice(i, 1)"
            >
              {{ doctor.name }}
            </el-tag>
          </el-row>
        </template>
        <template #rowIndex="{ row }">
          <span
            class="clickable"
            :class="
              doctors.findIndex((c) => c.id == row.id) >= 0
                ? 'artisan-input-checked'
                : 'artisan-input-uncheck'
            "
            @click="changeMember(row)"
          >
            <i class="el-icon-check"> </i>
          </span>
        </template>
      </ArtisanGrid>
      <template #footer>
        <el-button
          icon="el-icon-check"
          :disabled="!doctors.length"
          size="mini"
          type="success"
          @click="confirmGroup"
        >
          确认
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { saveGroup, removeGroup } from "@/api/bed/ward";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
export default {
  components: { Editor, Toolbar },
  data() {
    return {
      loading: false,
      row: {
        groups: [],
      },
      groupId: "",
      dialog: {
        title: "选择医疗组成员",
        show: false,
        loading: false,
        isAdd: false,
      },
      props: {
        label: "name",
        children: "members",
      },
      doctors: [],
      editor: null,
      toolbarConfig: {
        excludeKeys: [
          "editLink",
          "insertVideo",
          "uploadVideo",
          "uploadImage",
          "insertImage",
          "emotion",
        ],
      },
    };
  },
  computed: {
    groups() {
      if (this.row.groups) {
        let leaders = this.row.groups.filter((g) => g.groupId == "0");
        leaders.forEach((l) => {
          l.members = this.row.groups.filter((g) => g.groupId == l.id);
        });
        return leaders;
      }
      return [];
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  methods: {
    rowBtnPermission(row, btn) {
      if (btn.code == "createUser") {
        return false;
      }
      return true;
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    metaInited(option) {
      let column = option.columns.find((c) => c.code == "warnMatter");
      if (column) {
        column.isSlot = true;
      }
    },
    setWardGroup(row) {
      this.row = row;
    },
    addMembers(groupId) {
      this.groupId = groupId;
      this.doctors = [];
      this.dialog.title = "选择医疗组" + (groupId ? "成员" : "组长");
      this.dialog.show = true;
    },
    changeMember(row) {
      let index = this.doctors.findIndex((c) => c.id == row.id);
      console.log('index',index);
      if (index >= 0) {
        this.doctors.splice(index, 1);
      } else {
        this.doctors.push({ id: row.id, name: row.name });
      }
    },
    removeMember(data) {
      this.$refs.container.confirm({ msg: "确认删除？" }).then(() => {
        this.loading = true;
        removeGroup(this.row.id, data.id)
          .then(() => {
            this.loading = false;
            this.row.groups = this.row.groups.filter(
              (c) => c.id != data.id && c.groupId != data.id
            );
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    confirmGroup() {
      if (this.doctors.length) {
        let leader = {
          id: this.groupId,
          wardId: this.row.id,
        };
        leader.members = this.doctors;
        this.dialog.loading = true;
        saveGroup(leader)
          .then(() => {
            this.$message({
              type: "success",
              message: "添加成功！",
            });
            this.dialog.loading = false;
            this.dialog.show = false;
            let leaderId = "0";
            if (this.groupId) {
              leaderId = this.groupId;
            }
            this.doctors.forEach((c) => {
              this.row.groups.push({
                id: c.id,
                name: c.name,
                wardId: this.row.id,
                groupId: leaderId,
              });
            });
          })
          .catch(() => {
            this.dialog.loading = false;
          });
      }
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
